const id = '[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const uuid = new RegExp(`^${id}$`, 'i');
const path = new RegExp(`^/v1/intake/records/(${id})/processing-jobs$`, 'i');
const hasValues = object => Object.values(object || {}).some(value => value !== undefined && value !== null);
export const isIntakeProcessingCommand = record => record.method === 'POST' && path.test(record.path);
export const intakeProcessingType = item => {
  if (!item || !Number.isInteger(item.revision) || item.revision < 1 || item.revision >= 2147483647 || item.archived || item.archivedAt || item.sourceStatus !== 'uploaded'
    || item.reviewedAt !== null || hasValues(item.reviewFields) || hasValues(item.accountingEvidence)) return null;
  if (['Queued', 'Running'].includes(item.processing?.status)) return null;
  if (item.status === 'Needs review') return item.processing?.jobType === 'classify' && item.processing.status === 'Succeeded' ? 'extract' : null;
  if (!['New', 'Failed', 'Unsupported'].includes(item.status)) return null;
  const latestJobType = ['Failed', 'Unsupported'].includes(item.status)
    ? item.processing ? item.processing.jobType : item.processingHistory?.[0]?.jobType
    : null;
  return latestJobType === 'parse_bank_statement' || item.documentType === 'Bank statement' ? 'parse_bank_statement' : 'extract';
};
export const validateIntakeProcessingCommand = record => {
  const { body, intakeProcessing } = record;
  if (!intakeProcessing || !uuid.test(intakeProcessing.businessId) || !uuid.test(intakeProcessing.id)
    || path.exec(record.path)?.[1] !== intakeProcessing.id
    || typeof intakeProcessing.filename !== 'string' || !intakeProcessing.filename.trim() || intakeProcessing.filename.length > 255
    || !Number.isInteger(body.expectedRevision) || body.expectedRevision < 1 || body.expectedRevision >= 2147483647
    || !['extract', 'parse_bank_statement'].includes(body.jobType)
    || !/^[A-Za-z0-9._:-]{16,128}$/.test(body.processingIdempotencyKey)
    || body.parserKey !== null
    || Object.keys(body).sort().join(',') !== 'expectedRevision,jobType,parserKey,processingIdempotencyKey') {
    throw new Error('The original document processing request could not be verified.');
  }
};
export const verifyIntakeProcessingAcknowledgement = (record, job) => {
  validateIntakeProcessingCommand(record);
  if (!uuid.test(job?.id) || job.organization_id !== record.organizationId || job.business_id !== record.intakeProcessing.businessId
    || job.intake_record_id !== record.intakeProcessing.id || job.requested_by !== record.userId
    || job.job_type !== record.body.jobType || job.idempotency_key !== record.body.processingIdempotencyKey
    || job.status !== 'queued' || job.intake_revision !== record.body.expectedRevision + 1) {
    throw new Error('The processing receipt does not match the reviewed document.');
  }
};
